<ng-container *ngIf="AllLibraries.length > 0 || dynamicLibraries.length > 0; else notRelated">
  <div *ngFor="let Library of AllLibraries" class="Container-title">
    <!--&================== TITLE LIBRARY ==================&-->
    <div class="title-components">
      <h1>{{ Library.Title }}</h1>
    </div>

    <!--&================= CONTAINER CARD OPTION REPORT =================&-->
    <div class="Container-cards">
      <div *ngFor="let Sub_Library of Library.Library" class="Card">
        <div class="Top">
          <div class="img">
            <img src="./assets/Global/img/{{ Sub_Library.Img }}" alt="" />
          </div>
        </div>
        <div class="Body">
          <div class="Title">
            <h2>{{ Sub_Library.Library }}</h2>
          </div>
          <div class="Subtitle">
            {{ GetGreeting() }}, {{ NameUser() }},
            {{ Sub_Library.Description }}
          </div>
        </div>
        <div class="Bottom">
          <a
            [routerLink]="Sub_Library.RouteLink"
            class="Btn btn-icon-text-left"
          >
            <span class="text">Ver librería</span>
          </a>
        </div>
      </div>

      <ng-container *ngFor="let item of Library.NotRelated">
        <div></div>
      </ng-container>
    </div>
  </div>

  <!-- Contenedor para Librerías Dinámicas Adicionales -->
  <div *ngIf="dynamicLibraries.length > 0" class="Container-title">
    <div class="title-components">
      <h1>Librerías Adicionales</h1>
    </div>

    <div class="Container-cards">
      <div *ngFor="let lib of dynamicLibraries" class="Card"
           [class.show-actions-mobile]="selectedMobileLibSlug === lib.Slug"
           (click)="toggleMobileActions(lib.Slug, $event)">
        <div class="Top">
          <!-- Action Buttons (top-left) -->
          <div class="card-actions" (click)="$event.stopPropagation()">
            <button class="action-btn action-danger" title="Eliminar librería" (click)="DeactivateLibrary(lib)">
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>

          <div class="img">
            <img src="./assets/Global/img/Finance Processes.jpg" alt="" />
          </div>
        </div>
        <div class="Body">
          <div class="Title">
            <h2>{{ lib.Nombre }}</h2>
          </div>
          <div class="Subtitle">
            {{ GetGreeting() }}, {{ NameUser() }}, puede acceder a {{ lib.Nombre }}.
          </div>
        </div>
        <div class="Bottom">
          <a [routerLink]="['/Dashboard/Lib', lib.Slug]" class="Btn btn-icon-text-left" (click)="$event.stopPropagation()">
            <span class="text">Ver librería</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Botón Flotante de Creación (Estilo FAB) -->
  <div *ngIf="CanCreateLibraries" class="FAB-Container" (click)="CreateLibrary()">
    <button class="Btn-FAB">
      <i class="fa-solid fa-plus"></i>
      <span class="text">Crear librería</span>
    </button>
  </div>
</ng-container>

<ng-template #notRelated>
  <div class="title-components">
    <h1>CDMS</h1>
  </div>
  <div class="Container-Preview container-global-components">
    <div class="Not-Related">
      <div class="Img-Not">
        <img src="./assets/Global/Ilustrations/Not_Permission.png" alt="" />
      </div>
      <div class="Text-Not-Related">
        ¡Hola {{ NameUser() }}, actualmente no pertenece a ninguna librería. Por
        favor, contacte a su supervisor para que se le asigne una librería.!
      </div>
    </div>
  </div>
</ng-template>
